import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCouponH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 13a7 7 0 0 0-7 7v32a7 7 0 0 0 7 7h46a7 7 0 0 0 7-7V20a7 7 0 0 0-7-7zm-5 7a5 5 0 0 1 5-5h36.5v2.665a1 1 0 1 0 2 0V15H59a5 5 0 0 1 5 5v32a5 5 0 0 1-5 5h-7.5v-2.415a1 1 0 1 0-2 0V57H13a5 5 0 0 1-5-5zm43.5 2.523a1 1 0 1 0-2 0v5.83a1 1 0 1 0 2 0zm0 10.687a1 1 0 1 0-2 0v5.83a1 1 0 1 0 2 0zm0 10.688a1 1 0 1 0-2 0v5.83a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  }));
}
var IcCouponH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCouponH72));

export { IcCouponH72 as I };
